import { z } from "zod";
const KnowledgeBaseSyncProvider = {
  KUSTOMER: "kustomer"
};
const allKnowledgeBaseSyncProviders = Object.values(
  KnowledgeBaseSyncProvider
);
const knowledgeBaseSyncProviderSchema = z.enum(
  allKnowledgeBaseSyncProviders
);
const knowledgeBaseSyncProviderLabels = {
  [KnowledgeBaseSyncProvider.KUSTOMER]: "Kustomer"
};
const DEFAULT_KNOWLEDGE_BASE_SYNC_SCHEDULE = {
  frequency: "daily",
  time_of_day: "08:00"
};
function resolveKnowledgeBaseSyncScheduleSettings(settings) {
  return {
    sync_schedule: settings?.sync_schedule ?? DEFAULT_KNOWLEDGE_BASE_SYNC_SCHEDULE,
    autosync_enabled: settings?.autosync_enabled ?? true
  };
}
function maybeGetKnowledgeBaseExternalProvider(metadata) {
  return metadata?.external_provider ?? null;
}
const knowledgeBaseSyncRunIdSchema = z.uuid().brand();
function asKnowledgeBaseSyncRunId(id) {
  return knowledgeBaseSyncRunIdSchema.parse(id);
}
const KNOWLEDGE_BASE_SYNC_ACTIVE_RUN_MAX_AGE_MINUTES = 30;
const allKnowledgeBaseSyncRunStatuses = [
  "pending",
  "running",
  "completed",
  "failed"
];
const knowledgeBaseSyncRunStatusSchema = z.enum(
  allKnowledgeBaseSyncRunStatuses
);
export {
  DEFAULT_KNOWLEDGE_BASE_SYNC_SCHEDULE,
  KNOWLEDGE_BASE_SYNC_ACTIVE_RUN_MAX_AGE_MINUTES,
  KnowledgeBaseSyncProvider,
  allKnowledgeBaseSyncProviders,
  allKnowledgeBaseSyncRunStatuses,
  asKnowledgeBaseSyncRunId,
  knowledgeBaseSyncProviderLabels,
  knowledgeBaseSyncProviderSchema,
  knowledgeBaseSyncRunIdSchema,
  knowledgeBaseSyncRunStatusSchema,
  maybeGetKnowledgeBaseExternalProvider,
  resolveKnowledgeBaseSyncScheduleSettings
};
//# sourceMappingURL=knowledgeBaseSync.js.map
